import React from 'react'

import PlanItemCard from './PlanItemCard'
import {
  BoardAlertFragment,
  BoardGroupFragment,
  BoardItemFragment
} from '../../../../generated/graphql'
import { ModalName } from '../../../../types'
import useModal from '../../../../lib/hooks/useModal'
import useAppSettings from '../../../../lib/hooks/useAppSettings'

export type PlanItemCardWrapperProps = {
  /** List of alerts belonging to the group */
  alerts: Array<BoardAlertFragment>
  /** Campus used to filter courses */
  campus?: string
  /** Current Plan Group */
  group?: BoardGroupFragment
  /** If the plan is a template */
  isTemplate: boolean
  /** Current Plan Item */
  item: BoardItemFragment
  /** Whether the plan is read-only */
  readOnly?: boolean
}

const defaultProps: Pick<PlanItemCardWrapperProps, 'campus' | 'readOnly' | 'group'> = {
  campus: undefined,
  readOnly: false,
  group: undefined
}

const PlanItemCardWrapper = ({
  alerts,
  campus,
  group,
  isTemplate,
  item,
  readOnly
}: PlanItemCardWrapperProps) => {
  const { showModal } = useModal()
  const { academicPlanningSettings, sectionFieldText, text } = useAppSettings()
  const courseLabel = text.course
  const creditsLabel = sectionFieldText?.credits.substring(0, 2) || 'Cr'
  const termLabel = text.term
  const registeredLabel = text.registered
  const itemAlerts = alerts.filter((a) => a.itemId === item.id)
  const { showGradesOnPlanItems, showWithdrawnStatusOnPlanItems } = academicPlanningSettings

  // A registered/enrolled course cannot be deleted
  const disableDelete = item.enrollmentStatus?.enrolled || false

  // A course registered for the same term it is planned can not be moved to another term
  const disableGroupChange =
    (item.enrollmentStatus?.enrolled &&
      item.enrollmentStatus?.termCode &&
      group?.externalTermId &&
      item.enrollmentStatus.termCode === group.externalTermId) ||
    false

  const handleOpen = () =>
    showModal(ModalName.PlanItemDetails, {
      id: item.id,
      disableDelete,
      disableGroupChange,
      campus,
      isTemplate,
      planId: item.planId,
      readOnly
    })
  return (
    <PlanItemCard
      alerts={itemAlerts}
      courseLabel={courseLabel}
      creditsLabel={creditsLabel}
      item={item}
      index={item.displaySequence - 1}
      onOpen={handleOpen}
      readOnly={readOnly || disableGroupChange}
      registeredLabel={registeredLabel}
      showGrades={showGradesOnPlanItems}
      showWithdrawnAlert={showWithdrawnStatusOnPlanItems}
      termLabel={termLabel}
    />
  )
}

PlanItemCardWrapper.defaultProps = defaultProps

export default PlanItemCardWrapper
